import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {
	ClientFeatureOptions,
	Product,
	ClientFeatures,
} from '@uc/web/shared/data-models';
import { ClientValidatorService } from '@uc/web/core';

import { getFeatureKey } from '../../utils/utils';
import { CourseCardComponent } from '../course-card/course-card.component';
import { CourseDetails } from '../../models/course-search.models';
import { CourseCardBtnsComponent } from '../course-card/course-card-btns/course-card-btns.component';

@Component({
	selector: 'uc-course-card-container',
	templateUrl: './course-card-container.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CourseCardComponent, CourseCardBtnsComponent],
})
export class CourseCardContainerComponent {
	courses = input.required<CourseDetails[]>();
	clientFeatures = input.required<ClientFeatureOptions[]>();
	uniSlug = input.required<string>();
	uniId = input.required<number>();
	product = input.required<Product>();
	externalUrl = input.required<string>();
	uniName = input.required<string>();
	ugSearchOrderPosition = input.required<number | null>();
	searchTerm = input.required<string>();
	isHECoSSubject = input.required<boolean | null>();
	degreeLevel = input.required<string>();
	region = input.required<string>();

	isFeatured = computed(() =>
		this._cvSrv.checkFeature(
			this.clientFeatures(),
			ClientFeatures[getFeatureKey(this.product())],
		),
	);

	constructor(private _cvSrv: ClientValidatorService) {}

	track(id: number, index: number) {
		return `${id}-${index}`;
	}
}
